<template>
  <div class="sign-contract" data-title="申请流程">
    <applyPartner>
      <template v-slot:top >
        <p class="title">
          申请合伙人
        </p>
      </template>
      <template v-slot:left>
        <dl class="contract">
          <dt>
            <img src="../../assets/images/partner-img/5.png" alt="">
          </dt>
          <dd>
            签约合同
          </dd>
        </dl>
      </template>
      <template v-slot:right>
        <dl class="prove">
          <dt>
            <img src="../../assets/images/partner-img/2.png" alt="">
          </dt>
          <dd>
            完成认证
          </dd>
        </dl>
      </template>
    </applyPartner>
    <!-- 选择地域级 -->
    <territory :getPartnerlevelData="getPartnerlevelData" @level_id="get_level_id"></territory>
    <!-- 合同 -->
    <pact :level_id='level_id' :id='id'></pact>
  </div>
</template>

<script>

import applyPartner from '../../components/partner/apply-partner'
import territory from '../../components/partner/territory'
import pact from '../../components/partner/pact'

export default {
  data(){
    return{
      getPartnerlevelData: [], // 等级信息
      level_id:'', // 等级id
      id: '' // 合伙人信息id
    }
  },
  components:{
    applyPartner,
    territory,
    pact,
  },
  created(){
    this.id = this.$route.query.id
    this.$axios.post(this.domain.url+'/api/order/index/getPartnerlevelData').then((res) => {
      // console.log(res.data.data)
      this.getPartnerlevelData = res.data.data
    })
  },
  methods:{
    get_level_id(childid){
      this.level_id = childid
      // console.log(this.level_id)
    }
  }
}
</script>

<style>
  .sign-contract{
    width: 7.5rem;
    display: flex;
    flex-direction: column;
    background-image: url('../../assets/images/partner-img/bag@2x.png');
    background-size: 100% 100%;
  }
</style>